export const MAIN_URL = process.env.REACT_APP_API_URL;

export const CHECK_USER = 'api/check-user';

// President
export const GET_DICTIONARY = 'api/dictionary';
export const GET_LANGUAGE = 'api/get-language';
export const SET_LANGUAGE = 'api/set-language';
export const GET_LIST_LANGUAGE = 'api/get-list-language';

export const ADD_CONTACTS = 'api/add-contacts';
export const GET_SITEKEY = 'api/get-site-key';

export const ARTICLES = 'api/articles';
export const CONSTITUTIONS = 'api/constitutions';
export const CONSTITUTION_SPECIAL = 'api/constitution_special';
export const SEARCH = 'api/search';
export const SEARCH_BY_REGION = 'api/search_by_region';
export const BOOKS = 'api/books';
export const SEARCH_DOCUMENT = 'api/search_document';
export const EVENT_SEARCH_BY_GROUP = 'api/event_search_by_group';
export const EVENT_BY_BILATERAL_RELATIONS = 'api/event_type_by_theme_bilateral_relations';
export const EVENT_BY_INTERNAL_POLITICS = 'api/event_type_by_theme_internal_politics';
export const EVENT_BY_INTERN_STRUCTURES = 'api/event_type_by_theme_international_structures';
export const HOME_EVENT = 'api/home-event';
export const HOME_EVENT_NEWS = 'api/home_event_news';
export const HOME_SEARCH_DOCUMENT = 'api/search_document_home';
export const EVENT_BY_ID = 'api/event/show';
export const EVENT_FLICKER_IMAGES = 'api/event-flickr-images';
export const NODE_SHOW = 'api/event/nodeShow';
export const EVENT_MORE = 'api/event-more';
export const ADMINISTRATION = 'api/administration';
export const FILMS = 'api/films';
export const FILM_BY_ID = 'api/filmById';
export const STRUCTURES = 'api/structures';
export const STRUCTURES_BY_ID = 'api/structuresById';
export const BANNER = 'api/event-with-banner';
export const HOME_GALLERY = 'api/photo-videos-home';
export const AWARDS = 'api/awards';
export const LEADER = 'api/leader';
export const BIOGRAPHY = 'api/biography';
export const POWER = 'api/power';
export const SIGN = 'api/sign';
export const STANDART = 'api/standart';
export const EMBLEMS = 'api/emblems';
export const FLAGS = 'api/flags';
export const HYMNS = 'api/hymns';
export const MONEYS = 'api/moneys';
export const DECLARATION = 'api/decalaration';
export const JUDICIAL_POWER = 'api/judicial_power';
export const PEACEMAKING_EXPERIENCE = 'api/peacemaking_experience';
export const STRENGTHENING = 'api/strengthening';
export const FLICKR_IMAGES_WITH_SIZE = 'api/event-flickr-images-sizes';
